import { useDispatch } from 'react-redux'
import { handleOnKeyDown } from 'src/utils/Form'
import { actions } from '../../../../RestockingState'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { RestockingInfo } from 'src/features/restocking/RestockingTypes'
import * as S from './BadgeInput.styles'

interface FormData {
  badge: string;
}

const BadgeInput = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    register,
    trigger,
    getValues,
    setError,
    formState: { errors },
  } = useForm<FormData>()

  const onSuccess = (restockingInfo?: RestockingInfo) => {
    if (!restockingInfo) return
    const { startedPage, itemsToRestock } = restockingInfo
    const sourceAddress = startedPage.itemsToCollect?.addresses.find((address) => !address.done)

    if (sourceAddress) {
      dispatch(actions.setProperty({
        property: 'currentCollectRestockingAddress',
        value: sourceAddress,
      }))
    }

    if (itemsToRestock.length === 0 && startedPage.itemsToCollect?.entryCollectAddressRequired) {
      history.push('/restocking/webapp/entry-collect-address')
    } else if (itemsToRestock.length === 0 && !sourceAddress) {
      history.push('/restocking/webapp/forklift-question')
    } else if (sourceAddress) {
      if (!sourceAddress.started) {
        history.push('/restocking/webapp/collect-address')
      } else {
        history.push('/restocking/webapp/collect-product')
      }
    } else if (itemsToRestock.length > 0) {
      const currentProductToRestock = itemsToRestock.find((item) => item.started)

      if (currentProductToRestock) {
        dispatch(actions.setProperty({
          property: 'currentProductToRestock',
          value: currentProductToRestock,
        }))

        history.push('/restocking/webapp/restock-product')
        return
      }

      history.push('/restocking/webapp/restock-address')
    }
  }

  const onBadgeSubmit = async () => {
    const validationSuccess = await trigger('badge')

    if (validationSuccess) {
      dispatch(
        actions.validateBadge({
          badge: getValues('badge'),
          history,
          setError: (message) => setError('badge', { message }),
          onSuccess,
        }),
      )
    }
  }

  return (
    <S.Container>
      <S.CustomFieldMui
        onKeyDown={(e) => handleOnKeyDown(e, '', onBadgeSubmit)}
        inputProps={{ ...register('badge', { required: true }) }}
        error={!!errors.badge}
        helperText={errors.badge?.message}
        label='replacementForm.badgelabel'
        name='badge'
        testId='input-badge-restocking-test-id'
        type='password'
        size='medium'
        fullWidth
        autoComplete='off'
        autoFocus
      />
    </S.Container>
  )
}

export default BadgeInput
